export default __webpack_public_path__ + "static/media/b47a30708798c208.acb5bd9d396cc28855abd1a10240e07e.svg";